import { render, staticRenderFns } from "./TableBase.vue?vue&type=template&id=65417cda&scoped=true&lang=pug&"
import script from "./TableBase.vue?vue&type=script&lang=ts&"
export * from "./TableBase.vue?vue&type=script&lang=ts&"
import style0 from "./TableBase.vue?vue&type=style&index=0&id=65417cda&lang=stylus&scoped=true&"
import style1 from "./TableBase.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65417cda",
  null
  
)

export default component.exports